// Formato compartido por las vistas del reporte B2C.

export function formatNumber(n) {
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(Number(n) || 0);
}

export function signed(n) {
  return n > 0 ? `+${formatNumber(n)}` : formatNumber(n);
}
